export enum QuickFilterType {
    ALL = 'ALL',
    CRACK = 'CRACK',
    BASE = 'BASE',
    OUTSIDER = 'OUTSIDER',
}

export enum OEILLERES {
    SANS_OEILLERES = "SANS_OEILLERES",
    OEILLERES_AUSTRALIENNES = "OEILLERES_AUSTRALIENNES",
    OEILLERES_CLASSIQUE = "OEILLERES_CLASSIQUE"
}

export enum AVIS_ENTRAINEUR {
    POSITIF = "POSITIF",
    NEGATIF = "NEGATIF",
    NEUTRE = "NEUTRE"
}

export enum SexeEnum {
    MALES = "MALES",
    HONGRES = "HONGRES",
    FEMELLES = "FEMELLES"
}

export enum SORT_OPTION {
    SCORE = "SCORE",
    SCORE_PUR = "SCORE_PUR",
    PROBABILITY = "PROBABILITY",
    RED = "RED",
    COTE = "COTE",
    ELO = "ELO",
}

export enum Status {
    PARTANT = 'PARTANT',
    NON_PARTANT = 'NON_PARTANT',
}

export enum StatusCourse {
    ANNULEE = 'ANNULEE',
    ARRIVEE = 'ARRIVEE',
    A_PARTIR = 'A_PARTIR',
}

export enum Discipline {
    ATTELE = 'ATTELE',
    PLAT = 'PLAT',
    CROSS = 'CROSS',
    HAIE = 'HAIE',
    MONTE = 'MONTE',
    STEEPLECHASE = 'STEEPLECHASE',
}

export enum DISCIPLINE_OPTION {
    TROT = 'TROT',
    ATTELE = 'ATTELE',
    PLAT = 'PLAT',
    CROSS = 'CROSS',
    HAIE = 'HAIE',
    MONTE = 'MONTE',
    STEEPLECHASE = 'STEEPLECHASE',
}

export const DISCIPLINE_OPTION_TO_DISCIPLINES: Record<
    DISCIPLINE_OPTION,
    Discipline[]
> = {
    [DISCIPLINE_OPTION.TROT]: [
        Discipline.ATTELE,
        Discipline.MONTE,
    ],
    [DISCIPLINE_OPTION.ATTELE]: [Discipline.ATTELE],
    [DISCIPLINE_OPTION.MONTE]: [Discipline.MONTE],
    [DISCIPLINE_OPTION.PLAT]: [Discipline.PLAT],
    [DISCIPLINE_OPTION.CROSS]: [Discipline.CROSS],
    [DISCIPLINE_OPTION.HAIE]: [Discipline.HAIE],
    [DISCIPLINE_OPTION.STEEPLECHASE]: [Discipline.STEEPLECHASE],
};

export enum Terrain {
    POUZZOLANE = "POUZZOLANE",
    GAZON = "GAZON",
    HERBE = "HERBE",
    SABLE = "SABLE",
    PSF_STANDARD = "PSF_STANDARD"
}

export enum Corde {
    CORDE_GAUCHE = "CORDE_GAUCHE",
    CORDE_DROITE = "CORDE_DROITE",
}

export enum Deferre {
    DEFERRE_POSTERIEURS = "DEFERRE_POSTERIEURS",
    PROTEGE_ANTERIEURS_DEFERRRE_POSTERIEURS = "PROTEGE_ANTERIEURS_DEFERRRE_POSTERIEURS",
    DEFERRE_ANTERIEURS_POSTERIEURS = "DEFERRE_ANTERIEURS_POSTERIEURS",
    REFERRE_ANTERIEURS_POSTERIEURS = "REFERRE_ANTERIEURS_POSTERIEURS",
    DEFERRE_ANTERIEURS_PROTEGE_POSTERIEURS = "DEFERRE_ANTERIEURS_PROTEGE_POSTERIEURS",
    PROTEGE_POSTERIEURS = "PROTEGE_POSTERIEURS",
    DEFERRE_ANTERIEURS = "DEFERRE_ANTERIEURS",
    PROTEGE_ANTERIEURS_POSTERIEURS = "PROTEGE_ANTERIEURS_POSTERIEURS",
    PROTEGE_ANTERIEURS = "PROTEGE_ANTERIEURS",
}

export enum TypeCourse {
    GROUPE_I = 'GROUPE_I',
    GROUPE_II = 'GROUPE_II',
    GROUPE_III = 'GROUPE_III,',
    COURSE_A_CONDITIONS = 'COURSE_A_CONDITIONS',
    COURSE_A_CONDITION_QUALIF_HP = 'COURSE_A_CONDITION_QUALIF_HP',
    NATIONALE = 'NATIONALE',
    HANDICAP = 'HANDICAP',
    HANDICAP_DIVISE = 'HANDICAP_DIVISE',
    A_RECLAMER = 'A_RECLAMER',
    AUTOSTART = 'AUTOSTART',
    APPRENTIS_LADS_JOCKEYS = 'APPRENTIS_LADS_JOCKEYS',
    A_RECLAMER_APPRENTIS_LADS_JOCKEYS = 'A_RECLAMER_APPRENTIS_LADS_JOCKEYS',
    AMATEURS_AUTOSTART = 'AMATEURS_AUTOSTART',
    AMATEURS = 'AMATEURS',
    INCONNU = 'INCONNU',
}

export enum StatsTab {
    HIPPODROME = "HIPPODROME",
    DISCIPLINE = "DISCIPLINE",
    MONTANT = "MONTANT",
    TOP1 = "TOP1"
}

export enum EntityEnum {
    JOCKEY = "JOCKEY",
    TRAINER = "TRAINER",
    GROWER = "GROWER"
}

export enum MontantFilterEnum {
    INFERIEUR_10000 = "INFERIEUR_10000",
    INFERIEUR_20000 = "INFERIEUR_20000",
    INFERIEUR_35000 = "INFERIEUR_35000",
    SUPERIEUR_35000 = "SUPERIEUR_35000",
}

export enum EcartPrec {
    // Ex-aequo (dead-heat)
    EX_AEQUO = "Ex-Aequo",

    // Écarts minimes (photo-finish)
    NEZ = "NEZ",
    CTE_TETE = "CTE TETE",
    TETE = "TETE",
    CTE_ENCOLURE = "CTE ENC.",
    ENCOLURE = "ENCOLURE",

    // Fractions de longueur
    QUART_L = "1/4 L",
    DEMI_L = "1/2 L",
    TROIS_QUARTS_L = "3/4 L",

    // 1 à 2 longueurs
    L_1 = "1 L",
    L_1_25 = "1 L 1/4",
    L_1_5 = "1 L 1/2",
    L_1_75 = "1 L 3/4",
    L_2 = "2 L",
    L_2_5 = "2 L 1/2",

    // 3 à 9 longueurs
    L_3 = "3 L",
    L_3_5 = "3 L 1/2",
    L_4 = "4 L",
    L_4_5 = "4 L 1/2",
    L_5 = "5 L",
    L_5_5 = "5 L 1/2",
    L_6 = "6 L",
    L_6_5 = "6 L 1/2",
    L_7 = "7 L",
    L_7_5 = "7 L 1/2",
    L_8 = "8 L",
    L_8_5 = "8 L 1/2",
    L_9 = "9 L",
    L_9_5 = "9 L 1/2",

    // 10 longueurs et plus
    L_10 = "10 L",
    L_11 = "11 L",
    L_12 = "12 L",
    L_13 = "13 L",
    L_14 = "14 L",
    L_15 = "15 L",
    L_16 = "16 L",
    L_17 = "17 L",
    L_18 = "18 L",
    L_19 = "19 L",
    L_20 = "20 L",
    L_30 = "30 L",

    // Écart non mesurable
    LOIN = "LOIN",
}